import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "../../services/authentication.service";
import {
  ActivityIndicatorService,
  AuviousRtcService,
  GenericErrorHandler,
  UserService,
} from "../../services";

@Component({
  selector: "app-connection-status",
  templateUrl: "./connection-status.component.html",
  styleUrls: ["./connection-status.component.scss"],
  standalone: false,
})
export class ConnectionStatusComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authentication = inject(AuthenticationService);
  private rtcService = inject(AuviousRtcService);
  private user = inject(UserService);
  private activity = inject(ActivityIndicatorService);
  private errorHandler = inject(GenericErrorHandler);
  private destroyRef = inject(DestroyRef);

  isWarnOpen = false;
  isLoading = false;

  ngOnInit(): void {
    this.errorHandler.connectionError$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((_) => {
        this.isWarnOpen = true;
      });
    this.rtcService.connectionRegistered$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((_) => {
        this.isWarnOpen = false;
      });
  }

  async authenticate() {
    try {
      this.setLoading(true);
      // we are on the root route, walk down to the activated child route
      // so the strategy receives the snapshot that carries the route params
      let snapshot = this.route.snapshot;
      while (snapshot.firstChild) {
        snapshot = snapshot.firstChild;
      }
      await this.authentication.authenticate(snapshot);
      try {
        // unregister, just in case we have a messed up state. Skip if already
        // unregistered — the unregister request would just wait out its
        // internal timeout before rejecting.
        if (this.rtcService.registered()) {
          await this.rtcService.unregister();
        }
      } catch (ex) {
        // nothing
      }
      await this.rtcService.register();
      // we wait for the 'registered' event to hide the panel
    } catch (ex) {
      // this.
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(value: boolean) {
    this.isLoading = value;
    // this.activity.loading(value);
  }
}
